import * as lazy from "./lazyRouteComponents";

export default [
  {
    path: "",
    name: "insight:dashboard",
    component: lazy.DashboardIndex
  },
  {
    path: "surveys",
    name: "insight:surveyList",
    component: lazy.SurveyList
  },
  {
    path: "surveys/new",
    name: "insight:surveyCreate",
    component: lazy.CreateSurvey
  },
  {
    path: "surveys/:surveyId/report",
    name: "insight:surveyReport",
    component: lazy.SurveyReport
  },
  {
    path: "surveys/:surveyId/edit",
    name: "insight:surveyEdit",
    component: lazy.EditSurvey
  }
];
